module.exports = __webpack_public_path__ + "images/minus-ea1ef16d37508ff41b0309d29d471871.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/minus.svg
// module id = 228
// module chunks = 0